<template>
  <client-only>
    <div>
      <v-text-field
        id="password-login-field"
        v-model="password"
        :value="password"
        :append-icon="show1 ? ' mdi-eye' : ' mdi-eye-off'"
        :type="show1 ? 'text' : 'password'"
        solo
        :rules="passwordRules"
        label="סיסמא"
        prepend-inner-icon="mdi-lock"
        required
        clearable
        rounded
        @click:append="show1 = !show1"
        outlined
        dense
        :hint="'לפחות 6 תווים אותיות ומספרים בלבד'"
      />
      <div class="text-left mt-n8 ml-2" v-show="showRecoverLink">
        <v-btn
          color="primary "
          class="pa-0 text--secondary"
          text
          dark
          @click="passwordReset"
        >
          <span class="pointer-underline">שכחתי סיסמה</span>
        </v-btn>
      </div>
    </div>
  </client-only>
</template>

<script>
import { passwordRules } from '@/lib/rules.js';
/**
 * Reset password form
 */

export default {
  components: {},
  props: {
    showRecoverLink: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      show1: false,
      password: '',
      passwordRules,
    };
  },

  watch: {
    password() {
      this.applyPassword();
    },
  },

  methods: {
    passwordReset() {
      this.$bus.$emit('passwordReset', this.email);
    },

    applyPassword() {
      this.$emit('newPassword', this.password);
    },
  },
};
</script>
